import React from 'react';
import { FiltersKeys, ITeamLeadFilters } from './interface';
import styles from './TeamLead.module.scss';
import { _map } from '@cp/src/utils/commonUtils';
import SelectedFilterItem from './SelectedFilterItem';
import { getQueryString } from '.';

interface ISelectedFiltersOnDashboardProps {
  filters: ITeamLeadFilters;
  removeSelectedFilter: (filterKey: string) => void;
  handleRemoveFilters: () => void;
}

const CLEAR_ALL_FILTERS_COUNT = 1;

const SelectedFiltersOnDashboard: React.FC<ISelectedFiltersOnDashboardProps> = props => {
  const { filters, removeSelectedFilter, handleRemoveFilters } = props;
  const queryString = getQueryString();

  const data = _map(FiltersKeys, ({ key: filterKey, label }) => {
    const selectedFilters = queryString?.[filterKey as keyof typeof queryString];
    if (!selectedFilters) return null;
    return (
      <SelectedFilterItem
        filters={filters}
        removeSelectedFilter={removeSelectedFilter}
        filterKey={filterKey}
        label={label}
        selectedFilters={selectedFilters}
      />
    );
  }).filter(Boolean); // Filter out null values

  if (data.length > CLEAR_ALL_FILTERS_COUNT) {
    data.unshift(
      <div onClick={handleRemoveFilters} className={styles.clear} key="clear-all">
        Clear All
      </div>
    );
  }

  return <>{data.map((item, index) => React.cloneElement(item, { key: index }))}</>;
};

export default SelectedFiltersOnDashboard;
